import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import PPTToPDFUploadView from "./PPTToPDFUploadView";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PPTToPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PPT To PDF Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/ppt_to_pdf", title: "Convert PPT To PDF Online" },
    data2: { link: "/ppt_to_pdf", title: "Convert Powerpoint To PDF Free" },
    data3: { link: "/ppt_to_pdf", title: "Office Slides To PDF Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PPT to PDF online instantly. Turn PowerPoint presentations into high-quality PDFs quickly with our fast and secure PPT to PDF tool."
      ></meta>
      <meta
        name="keywords"
        content="ppt to pdf, convert ppt to pdf, powerpoint to pdf, ppt to pdf online, pptx to pdf, online ppt to pdf converter, convert presentation to pdf, ppt to pdf converter, powerpoint ppt to pdf, ppt file to pdf, ppt slides to pdf, ppt to pdf fast, ppt to pdf secure, powerpoint to pdf online, ppt document to pdf"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PPT View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <PPTToPDFUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pptx", "ppt"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                [".pptx"],
              "application/mspowerpoint": [".ppt"],
              "application/powerpoint": [".ppt"],
              "application/x-mspowerpoint": [".ppt"],
            }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PPT to PDF online website is a fast, secure, and easy to use solution for converting PowerPoint presentations into high quality PDF documents. Designed for speed and accuracy, this PowerPoint to PDF converter online supports PPT and PPTX files while preserving original slide layouts, fonts, images, charts, and overall formatting. Whether you are a student submitting assignments, a teacher sharing lecture slides, or a professional preparing business reports, this convert PPT to PDF online tool ensures your presentations look professional and consistent on every device. With a simple upload and convert process, users can transform PowerPoint files into universally compatible PDFs in just a few clicks. Our PPT to PDF converter online works directly in your browser, eliminating the need for complex software installations or technical expertise. All conversions are handled with strong security measures, ensuring your files remain private and are automatically removed after processing. PDF output files are optimized for easy sharing, printing, and long term storage, making them ideal for emails, presentations, documentation, and official submissions. If you’re looking for a reliable, high performance PowerPoint to PDF online converter that delivers accurate results without quality loss, this website provides a seamless document conversion experience you can trust." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PPT To PDF Converter"
          why_use={[
            {
              title: "Universal File Compatibility",
              description:
                "Using a PPT to PDF online converter ensures your PowerPoint files can be opened on any device and operating system without formatting issues. Converting PPT to PDF creates universally accessible documents that look consistent across all platforms.",
            },

            {
              title: "Preserves Original Formatting",
              description:
                "When you convert PPT to PDF online, all slide layouts, fonts, images, charts, and colors remain unchanged. Our reliable PowerPoint to PDF converter prevents formatting loss during sharing or viewing.",
            },

            {
              title: "Easy Sharing and Distribution",
              description:
                "PDF files are smaller and easier to share through email, messaging apps, and cloud platforms. Our PPT to PDF online website helps you distribute presentations quickly and professionally.",
            },

            {
              title: "Enhanced Security and Read Only Access",
              description:
                "Converting PowerPoint to PDF helps protect your content from unauthorized edits. This secure PPT to PDF online tool allows safe sharing of important presentations and documents.",
            },

            {
              title: "Offline Conversion for Data Privacy",
              description:
                "This online PPT to PDF converter processes files directly on your device without uploading them to servers. This ensures complete privacy when converting sensitive PowerPoint presentations.",
            },

            {
              title: "Professional Printing Output",
              description:
                "PDF is the preferred format for printing presentations. Using a PowerPoint to PDF online converter guarantees high quality, print ready documents with accurate page sizing.",
            },

            {
              title: "No Software Installation Required",
              description:
                "This browse based PPT to PDF online tool eliminates the need for installing heavy software. You can convert PowerPoint slides to PDF instantly with minimal effort.",
            },

            {
              title: "Faster Workflow and Productivity",
              description:
                "Our fast PPT to PDF converter online saves time by allowing quick and accurate conversions, helping students, teachers, and professionals improve productivity.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our PowerPoint to PDF online tool is perfect for business reports, presentations, assignments, and lecture slides, ensuring a professional and consistent document format.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "How do I convert PDF to PPT online for free?",
              description:
                "Open the PDF to PPT converter on ShivaPDF.com, select your PDF file, and start the conversion. Once processing is complete, download the resulting PowerPoint presentation if the download option is available. Review the slides to ensure the content and layout are correct.",
            },
            {
              title: "What is a PDF to PPT converter?",
              description:
                "A PDF to PPT converter transforms a PDF document into a PowerPoint presentation. It helps you reuse document content in slides for business meetings, classroom lessons, reports, and other presentations.",
            },
            {
              title: "Can I convert PDF to PowerPoint for free?",
              description:
                "An online PDF to PowerPoint converter can help you create a presentation without purchasing desktop conversion software. Check ShivaPDF's current tool page for free access, file-size limits, and any usage restrictions.",
            },
            {
              title: "Can I convert PDF to PPTX online?",
              description:
                "Yes, a converter that supports PPTX output can transform a PDF document into a PowerPoint-compatible presentation. Select your PDF and check the available output format before starting the conversion.",
            },
            {
              title: "What is the difference between PDF and PPT?",
              description:
                "PDF is a document format designed to preserve page layout, while PPT is a PowerPoint presentation format designed for slides. Converting PDF to PPT can help you reuse document content in a presentation workflow.",
            },
            {
              title: "What is the difference between PPT and PPTX?",
              description:
                "PPT is the older PowerPoint file format, while PPTX is the newer Office Open XML format. PPTX is widely supported by modern presentation software and is commonly used for new presentations.",
            },
            {
              title: "Can I edit a PowerPoint file after converting a PDF?",
              description:
                "You can edit the resulting presentation if the converter creates editable text and graphic elements. Some conversion methods place each PDF page into a slide as an image, which limits editing of individual elements.",
            },
            {
              title: "Will PDF to PPT conversion preserve the original formatting?",
              description:
                "A converter attempts to preserve text, images, fonts, and visual layout, but some formatting changes may occur. Complex tables, unusual fonts, charts, and multi-column layouts may need adjustments after conversion.",
            },
            {
              title: "Does each PDF page become a PowerPoint slide?",
              description:
                "Many PDF to PowerPoint converters create one slide for each PDF page. The exact slide structure depends on the tool, so check the resulting presentation to confirm that all pages have been converted as expected.",
            },
            {
              title: "Can I convert a multi-page PDF to PPT?",
              description:
                "Yes, a converter that supports multi-page PDFs can create a presentation from a document containing multiple pages. The number of pages you can process may depend on the tool's file and page limits.",
            },
            {
              title: "Can I convert a scanned PDF to PowerPoint?",
              description:
                "Scanned PDFs contain images of pages rather than directly accessible text. Converting them into editable slide content may require optical character recognition (OCR), depending on the converter's capabilities.",
            },
            {
              title: "Can I convert PDF to PPT without losing images?",
              description:
                "A PDF to PPT converter may preserve images and other visual elements, but their positioning, resolution, and size can change. Review the presentation after conversion to ensure important visuals appear correctly.",
            },
            {
              title: "Can I convert a PDF with charts and tables to PowerPoint?",
              description:
                "A converter may transfer charts and tables into the resulting presentation. Whether these elements remain individually editable depends on the conversion method and the structure of the original PDF.",
            },
            {
              title: "Can I convert PDF to PPT without installing software?",
              description:
                "Yes, a browser-based PDF to PPT converter lets you access the conversion process online without installing a separate desktop application, provided your device and browser are supported.",
            },
            {
              title: "Can I convert PDF to PowerPoint on Windows and Mac?",
              description:
                "A web-based PDF to PowerPoint converter can be used on Windows and macOS through a supported browser. You can access the tool without needing a dedicated desktop conversion program.",
            },
            {
              title: "Can I convert PDF to PPT on an iPhone or Android phone?",
              description:
                "You may be able to convert PDF files to PowerPoint using a mobile browser. The experience depends on the website's mobile compatibility, device memory, and the size and complexity of the PDF.",
            },
            {
              title: "Can I convert PDF to PPT offline?",
              description:
                "Offline conversion is possible when the conversion engine and required resources are available locally on your device. Many online PDF to PPT services require an internet connection, especially when files are processed on a remote server.",
            },
            {
              title: "Is it safe to convert PDF to PPT online?",
              description:
                "File privacy depends on how the conversion service processes and stores documents. Before converting confidential files, review the website's privacy policy and verify whether documents are uploaded, retained, or processed locally.",
            },
            {
              title: "Can I convert a password-protected PDF to PowerPoint?",
              description:
                "A password-protected PDF may need to be unlocked before conversion, depending on the tool. Only process documents you are authorized to access and follow the converter's supported steps for protected files.",
            },
            {
              title: "Why does my PowerPoint look different after PDF conversion?",
              description:
                "PDF pages and PowerPoint slides use different layout systems, which can affect fonts, spacing, text placement, and image scaling. Review the converted slides and adjust the formatting if necessary.",
            },
            {
              title: "Can I convert PDF to PPT for school or college presentations?",
              description:
                "Yes, converting PDF documents into PowerPoint can help students and teachers reuse notes, reports, handouts, and educational material in presentations. Check the slides for formatting and content accuracy before presenting.",
            },
            {
              title: "Can I convert PDF to PPT for business presentations?",
              description:
                "PDF to PPT conversion can help turn business reports, proposals, and document pages into presentation slides. Review confidential information and verify the accuracy of financial figures and other important details after conversion.",
            },
            {
              title: "Does converting PDF to PPT change the original PDF?",
              description:
                "PDF to PowerPoint conversion generally creates a separate presentation file and leaves the original PDF unchanged. Keep the original document if you need to preserve its layout or compare the converted content.",
            },
            {
              title: "Why should I use ShivaPDF's free PDF to PPT converter?",
              description:
                "An online PDF to PPT converter can help you reuse PDF content in presentation slides without installing desktop conversion software. Visit ShivaPDF's tool page to check current output formats, file limits, conversion options, and privacy details.",
            },
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PPTToPDFMain;
